<template>
  <div class="flex-layout" :style="computedStyle">
    <slot />
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
export default defineComponent({
  name: 'FlexLayout',
  props: {
    col: {
      type: Boolean,
      default: false,
    },
    justify: {
      type: String,
      // allowedValues removed: Vue props don't support this natively
      default: '',
    },
    align: {
      type: String,
      default: '',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    gap: {
      type: [String, Number],
      default: '0',
    },
  },
  setup (props) {
    const computedStyle = computed(() => {
      const justifyMap = {
        start: 'flex-start',
        end: 'flex-end',
        center: 'center',
        between: 'space-between',
        around: 'space-around',
        evenly: 'space-evenly',
      }
      const alignMap = {
        start: 'flex-start',
        end: 'flex-end',
        center: 'center',
        baseline: 'baseline',
        stretch: 'stretch',
      }

      return {
        display: props.inline ? 'inline-flex' : 'flex',
        flexDirection: props.col ? 'column' : 'row',
        justifyContent: props.justify ? (justifyMap[props.justify] || props.justify) : undefined,
        alignItems: props.align ? (alignMap[props.align] || props.align) : undefined,
        gap: typeof props.gap === 'number' ? `${props.gap}px` : props.gap,
      }
    })
    return { computedStyle }
  },
})
</script>

<style lang="postcss" scoped>
</style>
